import {BehaviorSubject, combineLatest} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {wwData$} from '@px/streams/worker-data';
import {isUtaSpot$} from '@px/streams/uta-state';

import SpotHistoryOrderData = ww.SpotHistoryOrderData;
import MarginHistoryOrderData = ww.MarginHistoryOrderData;
import Msg = ww.Msg;

type HistoryOrder = SpotHistoryOrder | MarginHistoryOrder;

export const historyOrders$ = new BehaviorSubject<HistoryOrder[]>([]);

combineLatest({isUtaSpot: isUtaSpot$, wwData: wwData$})
  .pipe(
    filter(({isUtaSpot, wwData}: {isUtaSpot: boolean; wwData: Msg<SpotHistoryOrderData | MarginHistoryOrderData>}) =>
      isUtaSpot ? wwData.type === 'uta-spot-orders-history' : wwData.type === 'spot-orders-history'
    ),
    map((o) => o.wwData)
  )
  .subscribe((msg: Msg<SpotHistoryOrderData | MarginHistoryOrderData>) => historyOrders$.next(msg.data.orders));
